export default __webpack_public_path__ + "static/frame-2229-3890c6933498ab77800b0551da2b6340.png";